import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0b983449")
const _hoisted_1 = { class: "icon-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, " Начать поиск ", -1)
_popScopeId()

import {RoundedIconButton} from "@/components"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(RoundedIconButton), {
      icon: "search",
      class: "icon"
    })
  ]))
}
}

})